import axios from "axios";

// Configure the global axios instance used across the app.
axios.defaults.baseURL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8080/api";

// Restore the auth token (if any) on a hard page reload, before the store
// has a chance to dispatch its attempt action.
const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export default axios;
